import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import useState from "react-usestateref";
import { sendcontactpageContacts } from "../../config/apiCall";
import { sendUnsubmitUserContacts } from "../../config/apiCall";
import httpService from "../../config/httpCall";
import { toastAlert } from "../../config/toastAlert";
import PhoneInput from "react-phone-input-2";

const NewFooter = () => {
  const [selectedPlatform2, setSelectedPlatform2] = useState("whatsApp");

  const NewFormValue = {
    newformmediumValue: "",
    newformmedium: "whatsApp",
    newformmessage: "",
    newformmobile: "",
    newformuserName: "",
    newformmobilecode: "",
  };

  const [newValue, setnewValue, newValueref] = useState(NewFormValue);

  const { newformuserName, newformmessage } = newValue;

  const [
    newformmediumValueErr,
    setnewformmediumValueErr,
    newformmediumValueErrref,
  ] = useState(false);
  const [newformmediumErr, setnewformmediumErr] = useState(false);
  const [newformmessageErr, setnewformmessageErr, newformmessageErrref] =
    useState(false);
  const [newformmobileErr, setnewformmobileErr, newformmobileErrref] =
    useState(false);
  const [newformuserNameErr, setnewformuserNameErr, newformuserNameErrref] =
    useState(false);
  const [newformmobilecodeErr, setnewformmobilecodeErr] = useState(false);
  const [validationErr, setvalidationErr, validationErrref] = useState("");
  const [platformInput, setPlatformInput, platformInputref] = useState("");

  const [NewFormNMobileCode, setNewFormNMobileCode] = useState();
  const [NewFormMobileValue, setNewFormMobileValue] = useState();
  const [NewFormcountry, setNewFormcountry] = useState();
  const [open, setOpen] = useState(false);
  const hasSentData = useRef(false);

  useEffect(() => {
    const sendDataOnce = () => {
      if (!hasSentData.current) {
        sendDataToBackend();
        hasSentData.current = true;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        sendDataOnce();
      }
    };

    const handleBeforeUnload = (event) => {
      sendDataOnce();
      event.preventDefault();
      event.returnValue = "";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [newValue, selectedPlatform2, platformInput, NewFormMobileValue]);

  const sendDataToBackend = async () => {
    try {
      const {
        newformuserName,
        newformmobilecode,
        newformmobile,
        newformmessage,
      } = newValueref.current;

      const userCountry = newValueref.current.NewFormcountry;
      const mediumDetail = platformInputref.current;
      // console.log("Data sent to backend starting *.*.*");

      if (
        newformuserName ||
        userCountry ||
        newformmobilecode ||
        newformmobile ||
        mediumDetail ||
        newformmessage
      ) {
        // console.log("Data sent to backend starting enters.....");
        const obj = {
          userName: newValueref.current.newformuserName,
          userCountry: newValueref.current.NewFormcountry,
          userCountryCode: newValueref.current.newformmobilecode,
          userMobilrNum: newValueref.current.newformmobile,
          contactMedium: selectedPlatform2,
          mediumDetail: platformInputref.current,
          userMessage: newValueref.current.newformmessage,
        };
        // console.log("Data sent to backend", obj);
        var messageSent = await sendUnsubmitUserContacts(obj);
        // console.log("messageSent---->>", messageSent);
      }
    } catch (error) {
      // console.error("Error sending data:", error);
    }
  };

  const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
    setNewFormMobileValue(value);
    setNewFormNMobileCode(countryObj.dialCode);
    setNewFormcountry(countryObj.name);
    newValueref.current["newformmobilecode"] = countryObj.dialCode;
    newValueref.current["newformmobile"] = value;
    newValueref.current["NewFormcountry"] = countryObj.name;
    setSelectedPlatform2("whatsApp");
    setPlatformInput("");
    validate(newValueref.current);
  };
  const validate = async (formData) => {
    try {
      var error = {};
      console.log(formData.newformmobilecode, "formData.newformmobilecode");
      const countryCodeLength = formData.newformmobilecode
        ? formData.newformmobilecode.length
        : "";
      const actualMobileLength = countryCodeLength
        ? formData.newformmobile.length - countryCodeLength
        : "";
      if (formData.newformuserName.trim() === "") {
        setnewformuserNameErr(true);
        error.newformuserName = "Must enter the field";
        setvalidationErr(error);
        return;
      } else if (formData.newformuserName.length < 3) {
        setnewformuserNameErr(true);
        error.newformuserName = "Invalid username, Must be 3-50 characters";
        setvalidationErr(error);
        return;
      } else {
        setnewformuserNameErr(false);
      }
      if (formData.newformmobile.trim() === "") {
        setnewformmobileErr(true);
        error.newformmobile = "Must enter the field";
        setvalidationErr(error);
        return;
      } else if (actualMobileLength < 7) {
        setnewformmobileErr(true);
        error.newformmobile =
          "Invalid number, Must be at least 7 digits excluding country code";
        setvalidationErr(error);
        return;
      } else {
        setnewformmobileErr(false);
      }
      if (
        (selectedPlatform2 === "email" && platformInputref.current === "") ||
        platformInputref.current.length == 0
      ) {
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Must enter the field";
        setvalidationErr(error);
        return;
      } else if (
        selectedPlatform2 === "email" &&
        !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
          platformInputref.current
        )
      ) {
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Invalid email format";
        setvalidationErr(error);
        return;
      } else if (
        ["whatsApp", "skype", "telegram"].includes(selectedPlatform2)
      ) {
        if (platformInputref.current.trim() === "") {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Must enter the field";
          setvalidationErr(error);
          return;
        } else if (
          selectedPlatform2 === "whatsApp" &&
          platformInputref.current.length < 7
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = `Whatsapp number must be at least 7 digits`;
          setvalidationErr(error);
          return;
        } else if (
          selectedPlatform2 === "skype" &&
          platformInputref.current.length < 5
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Skype ID / Number must be at least 5 characters`;
          setvalidationErr(error);
          return;
        } else if (platformInputref.current.length < 5) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Telegram ID / Number must be at least 5 characters`;
          setvalidationErr(error);
          return;
        } else {
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }

      if (formData.newformmessage.trim() === "") {
        setnewformmessageErr(true);
        error.newformmessage = "Must enter the field";
        setvalidationErr(error);
      } else if (formData.newformmessage.length < 3) {
        setnewformmessageErr(true);
        error.newformmessage = "Message must contain at least 3 characters";
        setvalidationErr(error);
      } else if (formData.newformmessage.length > 250) {
        setnewformmessageErr(true);
        error.newformmessage = "Message can't exceed 250 characters";
        setvalidationErr(error);
      } else {
        setnewformmessageErr(false);
      }
      setvalidationErr(error);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePlatformInputChange = (e) => {
    let value = e.target.value;
    if (e.target.type === "number") {
      if (value !== "" && parseFloat(value) < 0) {
        // value = "0";
        return;
      }
    }
    setPlatformInput(value);
    if (value && value.length > 0) {
      setnewformmediumErr(false);
      setvalidationErr((prev) => ({ ...prev, newformmedium: "" }));
    } else {
      setnewformmediumErr(true);
      setvalidationErr((prev) => ({
        ...prev,
        newformmedium: "Must enter the field",
      }));
    }
    // newValueref.current.newformmessage = "";
    validate(newValueref.current);
    if (
      selectedPlatform2 === "email" &&
      !/^[^\s@]+@[^\s@]+\.(com)$/.test(platformInputref.current)
    ) {
      validate(newValueref.current);
    }
  };

  const handleKeyPress = (e, maxLength, type) => {
    validate(newValueref.current);
    if (
      e.target.value.length >= maxLength &&
      ![
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ].includes(e.key)
    ) {
      e.preventDefault();
      return;
    }

    if (type === "email") {
      const validEmailChars = /^[a-zA-Z0-9@._-]+$/;
      if (
        !validEmailChars.test(e.key) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "number") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      // Prevent space at the start
      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }

      if (e.key === "e") {
        e.preventDefault();
        return;
      }

      // Allow only digits, plus symbol at the start, spaces in the middle, and control keys
      if (
        !/[0-9 ]/.test(e.key) &&
        !(e.key === "+" && cursorPosition === 0) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "text") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }
      if (
        value.length < maxLength ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        return;
      }

      e.preventDefault();
    }
  };

  const handlePlatformSelect = (e, platform) => {
    e.preventDefault();
    setSelectedPlatform2(platform);
    setPlatformInput("");
  };

  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;
      if (e.target.value.startsWith(" ")) {
        e.preventDefault();
        setnewValue((prevState) => ({
          ...prevState,
          [name]: value.trimStart(), // Remove leading spaces
        }));
        return;
        // / Prevent setting the value if it starts with a space
      } else {
        let formData = { ...newValue, ...{ [name]: value } };
        setnewValue(formData);
        await validate(formData);

        if (selectedPlatform2 && !platformInputref.current) {
          setnewformmediumValueErr(true);
        } else {
          setnewformmediumValueErr(false);
        }
      }
      // if (name === "newformmessage") {
      //   if (!value.trim()) {
      //     setnewformmessageErr(true);
      //   } else {
      //     setnewformmessageErr(false);
      //   }
      // }
    } catch (error) {
      console.error(error);
    }
  };

  const [buttonLoader, setbuttonLoader] = useState(false);

  const sendServiceContact = async (e) => {
    try {
      e.preventDefault();
      validate(newValueref.current);
      if (
        newValueref.current.newformuserName !== "" &&
        newformuserNameErrref.current === false &&
        newformmessageErrref.current === false &&
        newformmobileErrref.current === false &&
        newformmediumValueErrref.current == false &&
        newformmobilecodeErr === false &&
        newValueref.current.newformmessage != ""
      ) {
        setbuttonLoader(true);

        newValueref.current.newformmedium = selectedPlatform2;
        newValueref.current.newformmediumValue = platformInputref.current;

        var obj = {
          apiUrl: httpService.sendServiceContactDetails,
          payload: newValueref.current,
        };
        var messageSent = await sendcontactpageContacts(obj);
       
        newValueref.current.newformuserName = "";
        newValueref.current.newformmessage = "";
        newValueref.current.newformmobile = "";
        newValueref.current.newformmobilecode = "";
        setNewFormMobileValue("");
        setPlatformInput("");
        setNewFormNMobileCode("");
        setNewFormcountry();
        handleNewFormMobile("", "", "", "");
        if (messageSent.status == true) {
          toastAlert("success", messageSent.Message);
          setbuttonLoader(false);
        } else {
          toastAlert("error", messageSent.Message);
           setbuttonLoader(false);
        }
      } else {
        console.log("valnknkdnkdsnskn ds", newformuserNameErrref.current);
        validate(newValueref.current);
      }
    } catch (errr) {
      console.log("errr", errr);
       setbuttonLoader(false);
    }
  };

  const cancelpopup = () => {};

  return (
    <footer className="landing__footer">
      <a href="#" className="landing__footer-circle">
        <i className="fa-solid fa-arrow-up"></i>
      </a>
      <div className="primary__landing-content-container">
        <div className="landing__footer-links-wrapper">
          <ul className="landing__footer-links-list">
            {" "}
            <h6 className="footer-links-header">
              <span>
                <i className="fa-solid fa-chevron-right"></i>
              </span>
              Industries
            </h6>
            <li>
              <Link to="/contact-us">Finance</Link>
            </li>
            <li>
              <Link to="/contact-us">Banking</Link>
            </li>
            <li>
              <Link to="/contact-us">Insurance</Link>
            </li>
            <li>
              <Link to="/contact-us">Legal</Link>
            </li>
            <li>
              <Link to="/contact-us">Education</Link>
            </li>
            <li>
              <Link to="/contact-us">Health</Link>
            </li>
          </ul>
          <ul className="landing__footer-links-list">
            <li>
              <Link to="/contact-us">Game</Link>
            </li>
            <li>
              <Link to="/contact-us">Entertainment</Link>
            </li>
            <li>
              <Link to="/contact-us">Events</Link>
            </li>
            <li>
              <Link to="/contact-us">On Demand</Link>
            </li>
            <li>
              <Link to="/contact-us">Retail & E-Commerce</Link>
            </li>
            <li>
              <Link to="/contact-us">Restaurant</Link>
            </li>
          </ul>
          <ul className="landing__footer-links-list">
            <li>
              <Link to="/contact-us">Travel</Link>
            </li>
            <li>
              <Link to="/contact-us">Logistics</Link>
            </li>
            <li>
              <Link to="/contact-us">Energy Industry</Link>
            </li>
            <li>
              <Link to="/contact-us">Agriculture</Link>
            </li>
            <li>
              <Link to="/contact-us">Real Estates</Link>
            </li>
            <li>
              <Link to="/contact-us">Construction</Link>
            </li>
          </ul>
          <div>
            <h6 className="footer-links-header">
              <span>
                <i className="fa-solid fa-chevron-right"></i>
              </span>
              Services
            </h6>
            <ul className="landing__footer-links-list">
              <li>
                <Link to="/web3-development-solution">Web3 Solution</Link>
              </li>
              <li>
                <Link to="/custom-software-development-company">Software Development</Link>
              </li>
              <li>
                <Link to="/contact-us">Web App Development</Link>
              </li>
              <li>
                <Link to="/mobile-app-development-company">Mobile App Development</Link>
              </li>
              <li>
                <Link to="/forex-trading-software-development">
                  Forex Trading
                </Link>
              </li>
              <li>
                <Link to="/contact-us">Digital Marketing</Link>
              </li>
            </ul>
          </div>
          <div>
            <h6 className="footer-links-header">
              <span>
                <i className="fa-solid fa-chevron-right"></i>
              </span>
              Company
            </h6>
            <ul className="landing__footer-links-list">
              {/* <li>
                <a href="/contact-us">About</a>
              </li> */}
              <li>
                <Link to="/blog_details">Blog</Link>
              </li>
              <li>
                {/* <Link to="/roksy-the-best-meme-coin-to-buy-now">Press Release</Link> */}
                <Link to="/pressrelease">Press Release</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact</Link>
              </li>
              <li>
                <Link to="/career">Career</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="landing__footer-address-wrap">
          <div className="landing__footer-copyrights-flex">
            <div>
              {" "}
              <div>
                <h6 className="footer-links-header">
                  <span>
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                  Phone no.
                </h6>
                <div className="landing__footer-links-lists-wrap">
                  <ul className="landing__footer-links-list">
                    <li>
                      <h6 className="footer__link-address">+91 80567 86622</h6>
                    </li>
                    <li>
                      <h6 className="footer__link-address">+91 79043 23274</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              {" "}
              <div>
                <h6 className="footer-links-header">
                  <span>
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                  Contact HR
                </h6>
                <div className="landing__footer-links-lists-wrap">
                  <ul className="landing__footer-links-list">
                    <li>
                      <h6 className="footer__link-address">+91 7603980269</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              {" "}
              <div>
                <h6 className="footer-links-header">
                  <span>
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                  E-mail Address
                </h6>
                <div className="landing__footer-links-lists-wrap">
                  <ul className="landing__footer-links-list">
                    <a
                      href="mailto:business@beleaftechnologies.com"
                      target="_blank"
                    >
                      <li>
                        <h6 className="footer__link-address">
                          business@beleaftechnologies.com
                        </h6>
                      </li>
                    </a>
                    <a
                      href="mailto:business@beleaftechnologies.com"
                      target="_blank"
                    >
                      <li>
                        <h6 className="footer__link-address">
                          hr@beleaftechnologies.com
                        </h6>
                      </li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* New Pop Up */}
      <div id="myModal" className="modal fade contact_model" role="dialog">
        <div className="modal-dialog modal-md ">
          <div className="modal-content service-modal-content">
            <div>
              <div className="landing__contact--form hero-modal-contact">
                <form className="p-0">
                  <h4 className="landing__contact--form-title contact-us-title d-flex justify-content-between align-items-center">
                    Your Details
                    <button
                      type="button"
                      className="service-modal-btn"
                      data-dismiss="modal"
                      onClick={cancelpopup}
                    >
                      ×
                    </button>
                  </h4>
                  <div className="mt-4">
                    <label htmlFor="form-name" className="contact-us-label">
                      Name
                    </label>{" "}
                    <br />
                    <input
                      type="text"
                      id="form-name"
                      placeholder="Enter your name"
                      className="landing__form-input margin-bottom-land contact-us-input"
                      name="newformuserName"
                      autoComplete="off"
                      value={newformuserName}
                      max="50"
                      maxLength="50"
                      onChange={handleNewFormChange}
                      onBlur={(e) => handleKeyPress(e, 50, "text")}
                    />
                    {newformuserNameErrref.current &&
                    newformuserNameErrref.current === true ? (
                      <div className="text-danger font_error_newch">
                        {" "}
                        {validationErrref.current.newformuserName}{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-4">
                    <label htmlFor="mobile" className="contact-us-label">
                      Mobile Number
                    </label>{" "}
                    <br />
                    <PhoneInput
                      country={"us"}
                      value={NewFormMobileValue}
                      inputProps={{
                        name: "phonenumber",
                        required: true,
                      }}
                      autoComplete="off"
                      className="form-phone landing__form-input margin-bottom-land contact-us-input contact-us-phone"
                      onChange={(value, countryObj, e, formattedValue) =>
                        handleNewFormMobile(
                          value,
                          countryObj,
                          e,
                          formattedValue
                        )
                      }
                    />
                    {newformmobileErrref.current &&
                    newformmobileErrref.current === true ? (
                      <div className="text-danger font_error_newch">
                        {validationErrref.current.newformmobile}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-4">
                    <label htmlFor="form-contact" className="contact-us-label">
                      Contact Medium
                    </label>{" "}
                    <br />
                    <div className="form-contact-medium contact-us-input">
                      <button
                        type="button"
                        className="dropdown-toggle landing__form-dropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {selectedPlatform2 == "whatsApp" ? (
                          <i className="fa-brands fa-whatsapp"></i>
                        ) : selectedPlatform2 == "telegram" ? (
                          <i className="fa-brands fa-telegram"></i>
                        // ) : selectedPlatform2 == "skype" ? (
                        //   <i className="fa-brands fa-skype"></i>
                        ) : selectedPlatform2 == "email" ? (
                          <i className="fa fa-envelope" aria-hidden="true"></i>
                        ) : (
                          ""
                        )}
                      </button>
                      <div className="dropdown-menu landing__form-drop-menu">
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "whatsApp")}
                        >
                          <i className="fa-brands fa-whatsapp"></i>
                        </a>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "telegram")}
                        >
                          <i className="fa-brands fa-telegram"></i>
                        </a>
                        {/* <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "skype")}
                        >
                          <i className="fa-brands fa-skype"></i>
                        </a> */}
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "email")}
                        >
                          <i className="fa fa-envelope" aria-hidden="true"></i>
                        </a>
                      </div>

                      {selectedPlatform2 && (
                        <input
                          type={
                            selectedPlatform2 == "whatsApp" ? "number" : "text"
                          }
                          className="landing__contact-medium-input"
                          placeholder={`Enter your ${selectedPlatform2} ${
                            selectedPlatform2 == "email"
                              ? "Address"
                              : selectedPlatform2 === "whatsApp"
                              ? "number"
                              : "number / ID"
                          }`}
                          maxLength={
                            selectedPlatform2 === "email"
                              ? 250
                              : selectedPlatform2 === "whatsApp"
                              ? 15
                              : 32
                          }
                          value={platformInputref.current}
                          autoComplete="off"
                          onChange={handlePlatformInputChange}
                          onKeyDown={(e) =>
                            handleKeyPress(
                              e,
                              selectedPlatform2 === "email"
                                ? 250
                                : selectedPlatform2 === "whatsApp"
                                ? 15
                                : 32,
                              selectedPlatform2 === "email"
                                ? "email"
                                : selectedPlatform2 === "whatsApp"
                                ? "number"
                                : "text"
                            )
                          }
                        />
                      )}
                    </div>
                    {newformmediumValueErrref.current &&
                    newformmediumValueErrref.current === true ? (
                      <span className="text-danger font_error_newch">
                        {validationErrref.current.newformmediumValue}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-4">
                    <label htmlFor="message" className="contact-us-label">
                      Tell Us About Your Project
                    </label>
                    <br />
                    <textarea
                      id="message"
                      placeholder="Message"
                      className="landing__form-input landing-textarea landing__form-input margin-bottom-land contact-us-input"
                      rows="5"
                      name="newformmessage"
                      value={newformmessage}
                      max="250"
                      maxLength="250"
                      autoComplete="off"
                      onChange={handleNewFormChange}
                      onBlur={(e) => handleKeyPress(e, 250, "text")}
                    ></textarea>

                    {newformmessageErrref.current == true ? (
                      <div className="text-danger font_error_newch">
                        {validationErrref.current.newformmessage}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="text-center mt-4">
                    {buttonLoader == true ? (
                      <button className="primary-landing-main-btn" disabled>
                        loading....
                        <span className="ml-2 right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </button>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center">
                        <button
                          className="primary-landing-main-btn re-hero-btn nw-ct-btn"
                          onClick={sendServiceContact}
                        >
                          <div className="re-btn-txt">Submit</div>
                          <span className="ml-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                  {/* <div className="form-group row">
                    <div className="col-sm-12 mb-3">
                      <label>Name</label>
                      <input
                        type="text"
                        id="form-name"
                        placeholder="Enter your name"
                        className="form-control"
                        name="newformuserName"
                        autoComplete="off"
                        value={newformuserName}
                        max="50"
                        maxLength="50"
                        onChange={handleNewFormChange}
                        onBlur={(e) => handleKeyPress(e, 50, "text")}
                      />
                      {newformuserNameErr && newformuserNameErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErr.newformuserName}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="col-sm-12  pb-3">
                      <div className=" react-tel-input d-flex flex-column align-items-start">
                        <label>Mobile</label>

                        <PhoneInput
                          country={"us"}
                          value={NewFormMobileValue}
                          inputProps={{
                            name: "phonenumber",
                            required: true,
                          }}
                          autoComplete="off"
                          onChange={(value, countryObj, e, formattedValue) =>
                            handleNewFormMobile(
                              value,
                              countryObj,
                              e,
                              formattedValue
                            )
                          }
                        />

                        {newformmobileErr && newformmobileErr === true ? (
                          <span className="text-danger">
                            {" "}
                            {validationErr.newformmobile}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-sm-12 pb-3 contact-medium-label">
                      <label>Contact Medium</label>
                      <div className="border_sledct">
                        <button
                          type="button"
                          className="btn dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {selectedPlatform2 == "whatsApp" ? (
                            <i className="fa-brands fa-whatsapp"></i>
                          ) : selectedPlatform2 == "telegram" ? (
                            <i className="fa-brands fa-telegram"></i>
                          ) : selectedPlatform2 == "skype" ? (
                            <i className="fa-brands fa-skype"></i>
                          ) : selectedPlatform2 == "email" ? (
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            ""
                          )}
                        </button>
                        <div className="dropdown-menu">
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "whatsApp")}
                          >
                            <i className="fa-brands fa-whatsapp"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "telegram")}
                          >
                            <i className="fa-brands fa-telegram"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "skype")}
                          >
                            <i className="fa-brands fa-skype"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "email")}
                          >
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>

                        {selectedPlatform2 && (
                          <input
                            type="text"
                            className="form-control"
                            placeholder={`Enter your ${selectedPlatform2} ${
                              selectedPlatform2 == "email"
                                ? "Address"
                                : selectedPlatform2 === "whatsApp"
                                ? "number"
                                : "number / ID"
                            }`}
                            maxLength={
                              selectedPlatform2 === "email"
                                ? 250
                                : selectedPlatform2 === "whatsApp"
                                ? 15
                                : 32
                            }
                            value={platformInputref.current}
                            autoComplete="off"
                            onChange={handlePlatformInputChange}
                            onBlur={(e) =>
                              handleKeyPress(
                                e,
                                selectedPlatform2 === "email"
                                  ? 250
                                  : selectedPlatform2 === "whatsApp"
                                  ? 15
                                  : 32,
                                selectedPlatform2 === "email"
                                  ? "email"
                                  : selectedPlatform2 === "whatsApp"
                                  ? "number"
                                  : "text"
                              )
                            }
                          />
                        )}
                      </div>
                      <span className="text-danger">
                        {validationErr.newformmediumValue}
                      </span>
                    </div>
                    <div className="col-sm-12  pt-0 pb-0 contact-medium-label">
                      <label>Tell us about your project</label>

                      <textarea
                        id="message"
                        placeholder="Message"
                        className="form-control"
                        rows="5"
                        name="newformmessage"
                        value={newformmessage}
                        max="250"
                        maxLength="250"
                        autoComplete="off"
                        onChange={handleNewFormChange}
                        onBlur={(e) => handleKeyPress(e, 250, "text")}
                      ></textarea>
                      {newformmessageErr && newformmessageErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErr.newformmessage}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12 pr-0">
                    <div className="banner_text_section p-0">
                      <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text m-0"
                        tabindex="0"
                        type="button"
                        onClick={sendServiceContact}
                      >
                        Send Message
                      </button>
                    </div>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
